import styled from 'styled-components';
import Button from 'components/Button';
import CustomerPicker from 'components/CustomerPicker';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    gap: 0.75rem;
`;

export const StyledButton = styled(Button)`
    align-self: flex-start;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1rem;
    letter-spacing: 0.02688rem;
    padding: 1px 2px 1px 2px;

    &:focus {
        border: none;
        box-shadow: none;
    }

    svg {
        width: 1rem !important;
        height: 1rem !important;
        font-size: 1rem !important;
    }
`;

export const StyledCustomerPicker = styled(CustomerPicker)`
    width: 100%;
`;

export const Actions = styled.div`
    display: flex;
    padding: 0.5rem 0rem 0rem 1.5rem;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 1rem;
    align-self: stretch;
`;
